export enum ReportCustomFieldSettingType {
  NONE,
  GENERAL,
  ECI
}
